import React, { useContext, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import cn from 'classnames';
import { Chip } from '@mui/material';
import { AppContext } from 'Context';
import { Pathname } from 'Routes';
import { ReactComponent as PersonIcon } from 'Assets/person-profile.svg';
import { ReactComponent as HomeIcon } from 'Assets/home-header.svg';
import { ReactComponent as SearchIcon } from 'Assets/search.svg';
import { ReactComponent as WatchlistIcon } from 'Assets/watchlistIcon.svg';
import { VideoUploadModal } from 'Components/VideoUploadModal';
import { HeaderIconButton } from '../HeaderIconButton';
import styles from '../../index.module.css';

export const Header = ({ layoutType, profileDetails, revealProfileMenu, revealUploadModal, storageFullCondition, setStorageFull }) => {
  const { langText, isInActiveUser, openNewUploadModal, setOpenNewUploadModal } = useContext(AppContext);
  const headerText = langText?.header;
  const { profileID } = useParams();
  const location = useLocation();
  const isFromGift = new URLSearchParams(location.search).get('fromGift') === 'true';
  const giftSuffix = isFromGift ? '?fromGift=true' : '';

  // eslint-disable-next-line no-script-url
  window.location.href = 'javascript: $zopim.livechat.button.hide()';
  return (
    <>
      <header className={cn({ [styles.profileHeader]: true, [styles.videoBannerHeader]: true })}>
        <div className={styles.profileHeaderContent}>
          <div className={styles.leftContent} style={{ flex: '1' }}>
            <button
              aria-controls="profile-menu"
              className={cn({
                [styles.profileButton]: true,
                [styles.regularView]: true,
                [styles.profileHeaderIconButton]: true,
              })}
              onClick={revealProfileMenu('projectors')}
            >
              {
                profileDetails.image ? (
                  <img
                    src={profileDetails?.image}
                    className={cn({
                      [styles.profileMenuCurrentProfileDetailsIcon]: true,
                      [styles.border]: true,
                      [styles.profileIconPosition]: true,
                    })}
                  />
                ) : (
                  <PersonIcon
                    className={cn({
                      [styles.profileMenuCurrentProfileDetailsIcon]: true,
                      [styles.border2]: true,
                      [styles.profileIconPosition]: true,
                    })}
                  />
                )
              }
              <div className={`${styles.profileHeaderIconButtonText} ${styles.namePosition}`}>
                {profileDetails.firstname?.substring(0, 10) || profileDetails.email?.split('@')[0]?.substring(0, 10)}
              </div>
            </button>
            <HeaderIconButton
              icon={HomeIcon}
              text={headerText?.home || 'Home'}
              link={`${profileID ? Pathname.getFriendProfilePath(profileID) : Pathname.getProfilePath()}${giftSuffix}`}
            />
            <HeaderIconButton icon={SearchIcon} text={headerText?.search || 'Search'} link={Pathname.getFriendSearch(profileID)} />
            <HeaderIconButton icon={WatchlistIcon} text={headerText?.watchlist || 'Watchlist'} link={Pathname.getFriendWatchList(profileID)} />
          </div>
          <div className={styles.rightContent}>
            {
              !isInActiveUser ? (
                <>
                  <HeaderIconButton
                    text={headerText?.upload || 'UPLOAD'}
                    onClick={() => { storageFullCondition ? setStorageFull(true) : revealUploadModal(); }}
                    link="#"
                  />
                  <div style={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}>
                    <HeaderIconButton
                      text="NEW UPLOAD"
                      onClick={() => setOpenNewUploadModal(true)}
                      link="#"
                    />
                    <Chip
                      label="BETA"
                      size="small"
                      color="primary"
                      style={{
                        position: 'absolute',
                        top: -8,
                        right: -8,
                        height: 18,
                        fontSize: '10px',
                        fontWeight: 'bold',
                        backgroundColor: '#ff4444'
                      }}
                    />
                  </div>
                </>
              ) : null
            }
            <HeaderIconButton
              aria-controls="profile-menu"
              text={headerText?.account || 'ACCOUNT'}
              onClick={revealProfileMenu('account')}
              link="#"
            />
          </div>
        </div>
      </header>
      <VideoUploadModal
        open={openNewUploadModal}
        onClose={() => setOpenNewUploadModal(false)}
      />
    </>
  );
};
